/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { ContentRoute } from "../../../../_metronic/layout";
import Login from "./Login";
import Registration from "./Registration";
import ForgotPassword from "./ForgotPassword";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";
import ResetPassword from "./ResetPassword";
import UserVerified from "./UserVerified";
import OwnerTransfer from "./OwnerTransfer"; 

export function AuthPage() {
  return (
    <>
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
          id="kt_login"
        >
          {/*begin::Aside*/}
          <div
            className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10"
            style={{
              backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-15.jpg")})`,
            }}
          >
            {/*begin: Aside Container*/}
            <div className="d-flex flex-row-fluid flex-column justify-content-between">
              {/* start:: Aside header */}
              <div className=" mx-auto my-auto text-center">
                <img
                  alt="Logo"
                  className="max-h-150px"
                  src={toAbsoluteUrl("/media/logos/voni-logo.svg")}
                />
                <div className="font-size-h1 mt-5 text-primary">
                  {/* Welcome to Smart Touch! */}
                </div>
              </div>

              {/* end:: Aside header */}

              {/* start:: Aside footer for desktop */}
              <div className="d-none mx-auto flex-column-auto d-lg-flex justify-content-between mt-10">
                <div className="opacity-70 font-weight-bold	">
                  &copy; {new Date().getFullYear()} SmartIOT
                </div>
                <div className="d-flex">
               
                </div>
              </div>
              {/* end:: Aside footer for desktop */}
            </div>
            {/*end: Aside Container*/}
          </div>
          {/*begin::Aside*/}

          {/*begin::Content*/}
          <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
        
            {/* begin::Content body */}
            <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
              <Switch>
                <ContentRoute path={ "/auth/login"} component={Login} />
                <ContentRoute
                  path={ "/auth/registration"}
                  component={Registration}
                />
                <ContentRoute
                  path={ "/auth/forgot-password"}
                  component={ForgotPassword}
                />
                <ContentRoute path={ "/verification/reset-password/:id"} component={ResetPassword} />
                <ContentRoute path={ "/verification/verify-account/:id"} component={UserVerified} />
                <ContentRoute path={ "/verification/owner-transfer/:id"} component={OwnerTransfer} />
                <Redirect from={ "/auth"} exact={true} to={ "/auth/login"} />
                <Redirect to={ "/auth/login"} />
              </Switch>
            </div>
            {/*end::Content body*/}

            {/* begin::Mobile footer */}
            <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
              <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                &copy; {new Date().getFullYear()} SmartIOT
              </div>
            
            </div>
            {/* end::Mobile footer */}
          </div>
          {/*end::Content*/}
        </div>
        {/*end::Login*/}
      </div>
    </>
  );
}
